export function Optional(props) {
  const view = () => {
    if (props.show) {
      return props.children;
    } else {
      return <></>;
    }
  };
  return view();
}
